export enum ClientDetailsRegistrationStatusEnum {
  Active = 'Active',
  Released = 'Released',
  Unknown = 'Unknown',
}
